export default function UserAvatar({ user }: { user: Pick<{ displayName: string; avatarUrl: string | null }, 'displayName' | 'avatarUrl'> }) {
    const initials = user.displayName.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase()
    return user.avatarUrl ? (
        <img src={user.avatarUrl} alt={user.displayName} className="user-avatar" referrerPolicy="no-referrer" />
    ) : (
        <div className="user-avatar-fallback">{initials}</div>
    )
}
